<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <div
    pTooltip="{{
      !selectedChildRow || selectedChildRow.length === 0
        ? 'Select at least one child row before selecting a relationship'
        : ''
    }}"
    tooltipPosition="top"
  >
    <p-dropdown
      [options]="relationshipOptions"
      [(ngModel)]="reason"
      optionLabel="label"
      optionValue="value"
      placeholder="Select relationship"
      [appendTo]="'body'"
      class="w-full"
      [disabled]="!selectedChildRow || selectedChildRow.length === 0"
    ></p-dropdown>
  </div>

  <button
    class="py-1 px-5 border border-[#d9d9d9] rounded"
    (click)="onUpdateClick()"
    [disabled]="
      !selectedParentRow || !selectedChildRow || selectedChildRow.length === 0
    "
    [ngClass]="{
      'bg-[#1f273b] text-white cursor-pointer hover:bg-[#2a334a]':
        selectedParentRow,
      'bg-white text-gray-800 cursor-not-allowed': !selectedParentRow
    }"
    pTooltip="{{ !selectedParentRow ? 'Select a parent row' : '' }}"
    tooltipPosition="top"
  >
    Update
  </button>
</div>
<div class="flex gap-30">
  <div class="mb-4">
    <div class="flex gap-10 my-4">
      <input
        (keydown.enter)="onSearch()"
        [(ngModel)]="searchByParentName"
        type="text"
        placeholder="Search by parent name"
        class="border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
        (keydown)="preventSpaceKey($event)"
        (paste)="onPaste($event, 'searchByParentName')"
      />
      <select
        [(ngModel)]="selectedColorType"
        (change)="onSearch()"
        class="text-sm border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400 w-full sm:w-auto"
      >
        <option [ngValue]="undefined">Select color filter type</option>
        <option *ngFor="let type of formTypes" [ngValue]="type">
          {{ type }}
        </option>
      </select>
    </div>

    <div class="mb-4">
      <p-table
        [value]="unprocessedInsiderRelationship"
        [paginator]="unprocessedInsiderRelationship.length > 0"
        [first]="first"
        (onLazyLoad)="loadData($event)"
        [lazy]="true"
        [totalRecords]="paginator.totalCount"
        [rows]="paginator.pageSize"
        [loading]="isLoading"
        [showCurrentPageReport]="true"
        [tableStyle]="{ 'min-width': '40rem' }"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        (onPage)="pageChange($event)"
        [(selection)]="selectedParentRow"
        dataKey="insiderId"
        [rowsPerPageOptions]="[10, 25, 50]"
      >
        <ng-template #header>
          <tr>
            <th>Insider Id</th>
            <th>Insider Name</th>
            <th>Insider Comment</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        <ng-template #body let-insider>
          <tr
            [ngStyle]="{
              'background-color': insider.isParent
                ? 'lightgreen'
                : insider.hasParent
                ? 'lightblue'
                : ''
            }"
            [ngClass]="{
              'row-green': insider.isParent,
              'row-blue': insider.hasParent
            }"
          >
            <td>
              {{ insider.insiderId || insider.parentInsiderId || "N/A" }}
            </td>
            <td>
              {{ insider.insiderName || insider.parentInsiderName || "N/A" }}
            </td>
            <td>
              <textarea
                [(ngModel)]="insider.insiderComment"
                rows="2"
                class="w-full rounded-md border border-gray-300 p-2 text-sm focus:border-gray-400 focus:outline-none resize-none"
                placeholder="Enter comment..."
              ></textarea>
            </td>
            <td>
              <p-checkbox
                [binary]="true"
                [ngModel]="
                  selectedParentRow?.insiderId === insider.insiderId ||
                  (selectedParentRow?.parentInsiderId &&
                    selectedParentRow?.parentInsiderId ===
                      insider.parentInsiderId &&
                    selectedParentRow?.insiderId === insider.insiderId)
                "
                (onChange)="onParentCheckboxChange(insider)"
              ></p-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <ng-container
      *ngIf="!isLoading && unprocessedInsiderRelationship.length === 0"
    >
      <div class="text-center py-6 text-gray-500">No record found.</div>
    </ng-container>
  </div>
  <div class="mb-4">
    <div class="flex gap-10 my-4">
      <input
        (keydown.enter)="onChildSearch()"
        [(ngModel)]="searchByChildName"
        type="text"
        placeholder="Search by child name"
        class="border-b border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
        [disabled]="!selectedParentRow || selectedParentRow.length === 0"
        (keydown)="preventSpaceKey($event)"
        (paste)="onPaste($event, 'searchByChildName')"
        pTooltip="{{
          !selectedParentRow || selectedParentRow.length === 0
            ? 'Select at least one parent row'
            : ''
        }}"
        tooltipPosition="top"
      />
    </div>
    <p-table
      [value]="unprocessedChildInsiderRelationship"
      [paginator]="unprocessedChildInsiderRelationship.length > 0"
      [first]="first"
      (onLazyLoad)="loadChildData($event)"
      [lazy]="true"
      [totalRecords]="childPaginator.totalCount"
      [rows]="childPaginator.pageSize"
      [loading]="isChildLoading"
      [showCurrentPageReport]="true"
      [tableStyle]="{ 'min-width': '40rem' }"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      (onPage)="pageChange($event)"
      dataKey="insiderId"
      [(selection)]="selectedChildRow"
      [rowsPerPageOptions]="[10, 25, 50]"
    >
      <ng-template #header>
        <tr>
          <th>Insider Id</th>
          <th>Insider Name</th>
          <th>Insider Comment</th>
          <th>Actions</th>
        </tr>
      </ng-template>
      <ng-template #body let-insider>
        <tr [pSelectableRow]="insider">
          <td>
            {{ insider.childInsiderId || insider.insiderId || "N/A" }}
          </td>
          <td>
            {{ insider.childInsiderName || insider.insiderName || "N/A" }}
          </td>
          <td>
            <textarea
              [(ngModel)]="insider.childInsiderComment"
              rows="2"
              class="w-full rounded-md border border-gray-300 p-2 text-sm focus:border-gray-400 focus:outline-none resize-none"
              placeholder="Enter comment..."
            ></textarea>
          </td>
          <td>
            <p-checkbox
              [binary]="true"
              [ngModel]="
                selectedChildRow?.insiderId === insider.insiderId ||
                (selectedChildRow?.childInsiderId &&
                  selectedChildRow?.childInsiderId === insider.childInsiderId &&
                  selectedChildRow?.insiderId === insider.insiderId)
              "
              (onChange)="onChildCheckboxChange(insider)"
            ></p-checkbox>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <ng-container
      *ngIf="
        !isChildLoading && unprocessedChildInsiderRelationship.length === 0
      "
    >
      <div class="text-center py-6 text-gray-500">No record found.</div>
    </ng-container>
  </div>
</div>
<!-- <p-toast></p-toast> -->
